module.exports = __webpack_public_path__ + "static/media/Review-Unfinished.23452bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/reviews/Review-Unfinished.png
// module id = 123
// module chunks = 0